import { motion } from 'framer-motion';
// import capitalize from 'lodash/capitalize';
import React, { useContext } from 'react'
import { AiOutlineDollarCircle, AiOutlineSound } from 'react-icons/ai';
import { MdMoneyOff, MdOndemandVideo } from 'react-icons/md';
import { VscBook } from 'react-icons/vsc';
import { useHistory, useParams } from 'react-router-dom';
import DEFAULT_IMAGE from '../../assets/default_Images/default_Image.jpg';
import { AuthContext } from '../../context/auth';
import lang from '../../utils/translations';

// TODO - Semantic UI to be removed
import { Button } from 'semantic-ui-react';
import { FaCartPlus } from 'react-icons/fa';
import { RiMoneyDollarBoxFill } from 'react-icons/ri';


function ContentCard({book, onClickAddToCart}) {

  const history = useHistory();
  const params = useParams();
  const { user } = useContext(AuthContext);
  return params?.slug!==book?.slug && (
    <motion.div
    whileHover={{ scale: 1.1 }}
    className="d-flex justify-content-start flex-nowrap gap-2 shadow bg-white"
    style={{ borderTopLeftRadius: 40, borderBottomRightRadius: 40, cursor: 'pointer', userSelect: 'none' }}
    onClick={() => history.push(`/contents/${book?.slug}`)}
  >
    <img
      src={book?.coverUrl ? book?.coverUrl : DEFAULT_IMAGE}
      alt="cover"
      style={{ width: 170, height: 200, objectFit: 'fill', borderTopLeftRadius: 40, borderBottomRightRadius: 40 }}
    />
    <div className="p-2" style={{ overflow: 'hidden', width: 260 }}>
      <p className="fw-bold fs-5 text-blue-darken text-truncate m-0 pb-2" data-toggle="tooltip" title={book?.name}>
        {book?.name}
      </p>
      <p className="d-flex align-items-center justify-content-start flex-nowrap  m-0 pb-2">
        {book?.price !== 0 ? <AiOutlineDollarCircle size={30} className="text-blue-darken me-1" /> : <MdMoneyOff size={20} className="text-blue-darken me-1" />}
        <span className="fw-bold fs-4 text-blue-darken">
          {book?.price !== 0 ? book?.price : 'Free'}
        </span>
      </p>
      <p className="fw-light text-secondary text-truncate fs-6  m-0 pb-2" data-toggle="tooltip" title={book?.author}>
        Authored {lang.t('By')} {book?.author}
      </p>
      <p className="fw-light text-secondary text-truncate fs-6  m-0 pb-2" data-toggle="tooltip" title={book?.publishedCompany}>
        {lang.t('Published')} {lang.t('By')} {book?.publishedCompany}
      </p>

      {book?.price !== 0 ? (
        Number(user?.id) !== Number(book?.userId) ? (
          <div className="d-flex flex-nowrap justify-content-start align-items-center pb-2">
            <motion.button  whileHover={{scale:1.1}}
              onClick={() => onClickAddToCart(book?.id)}
              className="d-flex align-items-center flex-nowrap btn bg-blue-darken me-3"
              data-toggle="tooltip"
              title="Add to cart"
            >
              <FaCartPlus size={18} className="text-white me-1" />
              <div className="text-white font-11 no-white-space">{lang.t('Add To Cart')}</div>
            </motion.button>
            <motion.button  whileHover={{scale:1.1}}
              onClick={() => history.push(`/contents/${book?.slug}/pay`)}
              className="d-flex align-items-center flex-nowrap btn bg-blue-darken"
              data-toggle="tooltip"
              title="Buy it now"
            >
              <RiMoneyDollarBoxFill size={18} className="text-white me-1"/>
              <span className="text-white font-11 no-white-space">{lang.t('Buy It Now')}</span>
            </motion.button>
          </div>
        ) : (
          <div className="d-flex flex-nowrap justify-content-start align-items-center  py-2">
            <motion.button  whileHover={{scale:1.1}}
              onClick={() => (!user || Number(user?.id) !== Number(book?.userId) ? onClickAddToCart(book?.id) : {})}
              className="d-flex align-items-center flex-nowrap btn bg-blue-darken me-3" 
              data-toggle="tooltip"
              title="Add to cart"
            >
              <FaCartPlus size={18} className="text-white me-1" />
              <span className="text-white font-10 no-white-space">{lang.t('Add To Cart')}</span>
            </motion.button>
            <motion.button  whileHover={{scale:1.1}}
              onClick={() => history.push(`/contents/${book?.slug}`)}
              className="d-flex align-items-center flex-nowrap btn bg-blue-darken"
              data-toggle="tooltip"
              title="Buy it now"
            >
              <RiMoneyDollarBoxFill size={18} className="text-white me-1"/>
              <span className="text-white font-10 no-white-space">{lang.t('Buy It Now')}</span>
            </motion.button>
          </div>
        )
      ) : (
        <div className="d-flex flex-nowrap justify-content-start align-items-center py-2">
          <Button className="bg-blue-darken text-white" type="submit" onClick={() => history.push(`/contents/${book?.slug}`)}>
            Free
          </Button>
        </div>
      )}

      <div className="d-flex justify-content-between flex-nowrap gap-5 py-2 pe-2" style={{ borderTop: '5px solid #ccc' }}>
        <VscBook size={30} className={`${book?.hasBookUrl ? 'text-blue-darken' : 'text-grey'} cursor-pointer`} />
        <MdOndemandVideo size={30} className={`${book?.hasVideoUrl ? 'text-blue-darken' : 'text-grey'} cursor-pointer`} />
        <AiOutlineSound size={30} className={`${book?.hasAudioUrl ? 'text-blue-darken' : 'text-grey'} cursor-pointer`} />
      </div>
    </div>
  </motion.div>
  )
}

export default ContentCard
